'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://arcane-caverns-87314.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client8.js